import {ThemeSpacingName, ThemeColorName} from '../..';
import {ThemeBorderWidthNames} from '../../theme/types/ThemeBorder';
import {ButtonSize, ButtonKind, ButtonState} from './types';

export const ButtonPaddingMap: {
  [key in ButtonSize]: {
    icon: {
      horizontal: ThemeSpacingName;
      vertical: ThemeSpacingName;
    };
    normal: {
      horizontal: ThemeSpacingName;
      vertical: ThemeSpacingName;
    };
  };
} = {
  Default: {
    normal: {horizontal: '18', vertical: '10'},
    icon: {horizontal: '10', vertical: '10'},
  },
  Large: {
    normal: {horizontal: '20', vertical: '16'},
    icon: {horizontal: '10', vertical: '16'},
  },
  Small: {
    normal: {horizontal: '12', vertical: '8'},
    icon: {horizontal: '6', vertical: '8'},
  },
};

export const ButtonHeightMap: {
  [key in ButtonSize]: number;
} = {
  Small: 32,
  Default: 44,
  Large: 56,
};

export const IconPaddingMap: {
  [key in ButtonSize]: {
    horizontal: ThemeSpacingName;
    vertical: ThemeSpacingName;
  };
} = {
  Small: {horizontal: '4', vertical: '4'},
  Default: {horizontal: '6', vertical: '4'},
  Large: {horizontal: '10', vertical: '8'},
};

export const ButtonStyleMap: {
  [key in ButtonKind]: {
    [key in ButtonState]: {
      textColor: ThemeColorName;
      backgroundColor: ThemeColorName;
      borderColor?: ThemeColorName;
      borderSize?: keyof ThemeBorderWidthNames;
      iconReversed: boolean;
    };
  };
} = {
  Primary: {
    Default: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_accent_default',
      iconReversed: true,
    },
    Excited: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_accent_excited',
      iconReversed: true,
    },
    Disabled: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_accent_disabled',
      iconReversed: true,
    },
  },
  Secondary: {
    Default: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_mono_15',
      borderSize: '1',
      iconReversed: false,
    },
    Excited: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_mono_30',
      borderSize: '1',
      iconReversed: false,
    },
    Disabled: {
      textColor: 'content_mono_disabled',
      backgroundColor: 'background_mono_primary',
      borderColor: 'border_mono_15',
      borderSize: '1',
      iconReversed: false,
    },
  },
  Clear: {
    Default: {
      textColor: 'content_mono_secondary',
      backgroundColor: 'transparent',
      iconReversed: false,
    },
    Excited: {
      textColor: 'content_mono_primary',
      backgroundColor: 'transparent',
      iconReversed: false,
    },
    Disabled: {
      textColor: 'content_mono_disabled',
      backgroundColor: 'transparent',
      iconReversed: false,
    },
  },
  Inverse: {
    Default: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_mono_inverse_primary',
      iconReversed: true,
    },
    Excited: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_mono_inverse_excited',
      iconReversed: true,
    },
    Disabled: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_mono_inverse_disabled',
      iconReversed: true,
    },
  },
  Negative: {
    Default: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_negative_default',
      iconReversed: true,
    },
    Excited: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_negative_excited',
      iconReversed: true,
    },
    Disabled: {
      textColor: 'content_mono_inverse_disabled',
      backgroundColor: 'background_negative_disabled',
      iconReversed: true,
    },
  },
  Positive: {
    Default: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_positive_default',
      iconReversed: true,
    },
    Excited: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_positive_excited',
      iconReversed: true,
    },
    Disabled: {
      textColor: 'content_mono_inverse_disabled',
      backgroundColor: 'background_positive_disabled',
      iconReversed: true,
    },
  },
  Warning: {
    Default: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_warning_default',
      iconReversed: true,
    },
    Excited: {
      textColor: 'content_mono_inverse_primary',
      backgroundColor: 'background_warning_excited',
      iconReversed: true,
    },
    Disabled: {
      textColor: 'content_mono_inverse_disabled',
      backgroundColor: 'background_warning_disabled',
      iconReversed: true,
    },
  },
};
